import React from 'react'
import Messenger from 'components/stream-messaging/messenger'
import SensitiveInfoWrapper from 'lib/auth/SensitiveInfoWrapper'

const MessagesPage = () => (
  <SensitiveInfoWrapper enableFallback>
    <Messenger />
  </SensitiveInfoWrapper>
)

export default MessagesPage
